"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShimmerLine = void 0;
var Utilities_1 = require("../../../Utilities");
var ShimmerLine_base_1 = require("./ShimmerLine.base");
var ShimmerLine_styles_1 = require("./ShimmerLine.styles");
exports.ShimmerLine = (0, Utilities_1.styled)(ShimmerLine_base_1.ShimmerLineBase, ShimmerLine_styles_1.getStyles, undefined, {
    scope: 'ShimmerLine',
});
//# sourceMappingURL=ShimmerLine.js.map